import { DateTime } from 'luxon';

import { Campaign, CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';
import { convertMonetaryIntToDecimal } from 'common/utils/currencyDecimals';

import { API_UNLIMITED_TOTAL_BUDGET_SUM, UNLIMITED_TOTAL_BUDGET_SUM } from '../../components/budget-section/constants';
import { CampaignListItem, CampaignStatus } from '../../types';
import { getCampaignActions } from '../getCampaignActions';
import { getCampaignStatus } from '../getCampaignStatus';

const getIsCampaignBudgetExceeded = (campaign: Campaign): boolean =>
  !!campaign.total_budget_sum &&
  !!campaign.total_spent_budget &&
  campaign.total_spent_budget > campaign.total_budget_sum;

export const transformCampaignApiToCampaignListItem = (
  campaign: Campaign,
  timezone: string,
  country: Country,
  currency: Currency,
  isMerchantLevel: boolean,
): CampaignListItem => {
  const campaignStatus = getCampaignStatus(campaign) || CampaignStatus.SCHEDULED;
  const campaignType = campaign.is_end_of_day_campaign ? CampaignType.END_OF_DAY : campaign.campaign_type;
  return {
    campaignId: campaign.id,
    campaignType,
    startDate: DateTime.fromISO(campaign.start_date).setZone(timezone).toISO(),
    endDate: DateTime.fromISO(campaign.end_date).setZone(timezone).toISO(),
    budget:
      campaign.total_budget_sum === API_UNLIMITED_TOTAL_BUDGET_SUM
        ? UNLIMITED_TOTAL_BUDGET_SUM
        : convertMonetaryIntToDecimal(Number(campaign.total_budget_sum), currency),
    status: campaignStatus,
    allowedActions: getCampaignActions({
      campaignType,
      campaignStatus,
      country,
      isCreatedByWolt: campaign.created_by_wolt,
      isMerchantLevel,
      venueIds: campaign.venue_ids,
    }),
    paidBy: campaign.budget_type,
    isCreatedByWolt: campaign.created_by_wolt,
    isBudgetExceeded: getIsCampaignBudgetExceeded(campaign),
    venueIds: campaign.venue_ids,
  };
};
